import React, { Component } from 'react';

import CheckboxChecked from 'icons/CheckboxChecked';
import CheckboxUnChecked from 'icons/CheckboxUnChecked';
import './Checkbox.scss';
import classNames from 'classnames';

class Checkbox extends Component {
  onCheck = () => {
    if(!this.props.disabled) {
      this.props.onCheck(!this.props.value);
    }
  }

  render() {
    return (
      <div className={classNames("checkbox", {"disabled": this.props.disabled})} onClick={this.onCheck}>
        { this.props.value &&
          <CheckboxChecked />
        }
        { !this.props.value &&
          <CheckboxUnChecked />
        }
        <div>
          {this.props.label}
        </div>
      </div>
    );
  }
}

export default Checkbox;
